export default "__VITE_ASSET__CPEzpqch__"